import React from 'react';
import { Img } from 'react-image';

interface Props {
	handleBackArrow: () => void;
	title: string;
}

const TitleBar = ({ handleBackArrow, title }: Props) => {
	return (
		<>
			<div className="flex items-center gap-3">
				<div className="cursor-pointer" onClick={handleBackArrow}>
					<Img loading="lazy" src="/assets/arrowLeft.svg" alt="arrowLeft" width="24" height="24" />
				</div>
				<div className="text-xl font-bold whitespace-nowrap overflow-hidden text-ellipsis">{title} Scorecard</div>
			</div>
		</>
	);
};

export default TitleBar;
